import { useDarkmode } from "hooks/useTheme";
import { QRCodeSVG } from "qrcode.react";
import { useEffect, useState } from "react";
import AtriumApi from "api";
import { useSearchParams } from "react-router-dom";
import Avatar from "components/avatar";

const CheckOut = () => {
  const { darkmode } = useDarkmode();
  const [entries, setEntries] = useState([]);
  const [guardians, setGuardians] = useState([]);

  const [queryParams] = useSearchParams();
  const code = queryParams.get("code");
  if (!code) throw new Error("not-found");

  useEffect(() => {
    AtriumApi.get("/v1/check-in", { params: { code: code } }).then((resp) => {
      setGuardians([resp.data.user, ...resp.data.guardians]);
      setEntries(resp.data.entries);
    });
  }, [code]);

  return (
    <>
      <div className="flex-1 max-w-[390px] py-2 px-4">
        <h1 className="text-3xl font-bold">
          Show QR code to staff member to check-out.
        </h1>

        <div className="flex flex-col gap-2 mt-4">
          {entries.map(({ kid, room, ...entry }, i) => (
            <div
              key={"kid" + i}
              className={`bg-white select-none dark:bg-navy-700 flex flex-row items-center p-2 rounded-xl gap-6`}
            >
              <Avatar user={kid} />
              <div className="flex-1">
                <p className="font-bold text-normal">
                  {kid.firstName} {kid.lastName}
                </p>
                <div className="flex flex-row gap-2 items-end">
                  <div className="flex-1">
                    <p className="text-gray-700 text-sm">
                      {new Date().getFullYear() -
                        new Date(kid.dob).getFullYear()}{" "}
                      years
                    </p>
                    <p className="text-gray-700 text-sm mt-3">{room?.name}</p>
                  </div>
                  <div className="mt-3 text-right">
                    {entry.checkinAt ? (
                      <div className="text-sm font-medium">
                        <div className="border-b-2 border-gray-500">
                          {new Date(entry.checkinAt).toLocaleTimeString([], {
                            minute: "2-digit",
                            hour: "2-digit",
                          })}
                        </div>
                        <div>
                          {entry.checkoutAt ? (
                            new Date(entry.checkoutAt).toLocaleTimeString([], {
                              minute: "2-digit",
                              hour: "2-digit",
                            })
                          ) : (
                            <span className="text-sm font-medium text-green-700">
                              On-site
                            </span>
                          )}
                        </div>
                      </div>
                    ) : (
                      <p>Processing</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="flex flex-col gap-1 rounded-2xl my-1">
          <div className="flex flex-row gap-1">
            {guardians.map((user) => (
              <div
                className="flex-1 rounded-2xl bg-white dark:bg-navy-700 p-4"
                key={`guardian${user.id}`}
              >
                <p className="text-gray-700 text-sm">Parent</p>
                <p className="text-base font-medium">
                  {user.firstName} {user.lastName}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* <div className='flex flex-row gap-1 mt-1'>
                    <div className="flex-1 rounded-2xl bg-white dark:bg-navy-700 p-4">
                        <p className="text-gray-700 text-sm">Check-in</p>
                        <p className="text-base font-medium">{new Date().toLocaleTimeString([], {minute: '2-digit', hour: '2-digit'})}</p>
                    </div>

                    <div className="flex-1 rounded-2xl bg-white dark:bg-navy-700 p-4">
                        <p className="text-gray-700 text-sm">Check-out</p>
                        <p className="text-base font-medium text-green-700">On-site</p>
                    </div>
                </div> */}

        <div className="flex flex-col items-center rounded-2xl bg-white dark:bg-navy-700 p-8 mt-2">
          <QRCodeSVG
            value={code}
            size={240}
            bgColor={"transparent"}
            fgColor={darkmode ? "white" : "#1F264E"}
          />
        </div>
      </div>
    </>
  );
};

export default CheckOut;
